import React from "react";

const Icons = {
	grid: (
		<svg
			width="20"
			height="20"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="1.75"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<rect x="3" y="3" width="7" height="7" rx="1" />
			<rect x="14" y="3" width="7" height="7" rx="1" />
			<rect x="14" y="14" width="7" height="7" rx="1" />
			<rect x="3" y="14" width="7" height="7" rx="1" />
		</svg>
	),
	clock: (
		<svg
			width="20"
			height="20"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="1.75"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<circle cx="12" cy="12" r="10" />
			<polyline points="12 6 12 12 16 14" />
		</svg>
	),
	gitBranch: (
		<svg
			width="20"
			height="20"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="1.75"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<line x1="6" y1="3" x2="6" y2="15" />
			<circle cx="18" cy="6" r="3" />
			<circle cx="6" cy="18" r="3" />
			<path d="M18 9a9 9 0 0 1-9 9" />
		</svg>
	),
	list: (
		<svg
			width="20"
			height="20"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="1.75"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<line x1="8" y1="6" x2="21" y2="6" />
			<line x1="8" y1="12" x2="21" y2="12" />
			<line x1="8" y1="18" x2="21" y2="18" />
			<line x1="3" y1="6" x2="3.01" y2="6" />
			<line x1="3" y1="12" x2="3.01" y2="12" />
			<line x1="3" y1="18" x2="3.01" y2="18" />
		</svg>
	),
	fileText: (
		<svg
			width="20"
			height="20"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="1.75"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
			<polyline points="14 2 14 8 20 8" />
			<line x1="16" y1="13" x2="8" y2="13" />
			<line x1="16" y1="17" x2="8" y2="17" />
		</svg>
	),
	bookOpen: (
		<svg
			width="20"
			height="20"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="1.75"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path d="M2 4.5A2.5 2.5 0 0 1 4.5 2H11v18H4.5A2.5 2.5 0 0 1 2 17.5z" />
			<path d="M22 4.5A2.5 2.5 0 0 0 19.5 2H13v18h6.5a2.5 2.5 0 0 0 2.5-2.5z" />
		</svg>
	),
	play: (
		<svg
			width="20"
			height="20"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="1.75"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<polygon points="5 3 19 12 5 21 5 3" />
		</svg>
	),
	cpu: (
		<svg
			width="20"
			height="20"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="1.75"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<rect x="4" y="4" width="16" height="16" rx="2" />
			<rect x="9" y="9" width="6" height="6" />
			<line x1="9" y1="1" x2="9" y2="4" />
			<line x1="15" y1="1" x2="15" y2="4" />
			<line x1="9" y1="20" x2="9" y2="23" />
			<line x1="15" y1="20" x2="15" y2="23" />
			<line x1="20" y1="9" x2="23" y2="9" />
			<line x1="20" y1="14" x2="23" y2="14" />
			<line x1="1" y1="9" x2="4" y2="9" />
			<line x1="1" y1="14" x2="4" y2="14" />
		</svg>
	),
	toolCase: (
		<svg
			width="20"
			height="20"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="1.75"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<rect x="2" y="7" width="20" height="14" rx="2" />
			<path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2" />
		</svg>
	),
	graduationCap: (
		<svg
			width="20"
			height="20"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="1.75"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path d="M22 10v6M2 10l10-5 10 5-10 5z" />
			<path d="M6 12v5c3 3 9 3 12 0v-5" />
		</svg>
	),
	settings: (
		<svg
			width="20"
			height="20"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="1.75"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<circle cx="12" cy="12" r="3" />
			<path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
		</svg>
	)
};

const NAV_ITEMS = [
	{ id: "overview", label: "Overview", icon: "grid", testOnly: true },
	{ id: "agents", label: "Agents", icon: "cpu", testOnly: true },
	{ id: "prompt-docs", label: "Prompts", icon: "bookOpen" },
	{ id: "skill-docs", label: "Skills", icon: "fileText" },
	{ id: "mcp-tools", label: "MCP Tools", icon: "toolCase", divider: true  },
	{ id: "pending-actions", label: "Actions Queue", icon: "clock", pendingBadge: true, testOnly: true },
	{ id: "manual-trigger", label: "Manual Trigger", icon: "play", testOnly: true },
	{ id: "workflow-runs", label: "Workflow Runs", icon: "gitBranch", testOnly: true },
	{ id: "reports", label: "Reports", icon: "fileText", divider: true, testOnly: true },
	{ id: "audit-log", label: "Audit Log", icon: "list", testOnly: true },
	{ id: "learn", label: "Learn", icon: "graduationCap", testOnly: true },
	{ id: "settings", label: "Settings", icon: "settings", testOnly: true }
];

export default function AopSidebar({ currentView, onViewChange, isTestEnv, status, mobileOpen, onClose }) {
	const visibleItems = NAV_ITEMS.filter((item) => isTestEnv || !item.testOnly);
	const pendingCount = status ? status.pendingActions : 0;

	return (
		<>
		<div className={`aop-sidebar-backdrop${mobileOpen ? " open" : ""}`} onClick={onClose} />
		<aside className={`aop-sidebar${mobileOpen ? " open" : ""}`}>
			<nav className="aop-sb-nav">
				{visibleItems.map((item) => {
					const isActive = currentView === item.id;
					return (
						<div
							key={item.id}
							className={`aop-nav-item${isActive ? " active" : ""} ${item.divider ? " aop-sb-nav-bb" : ""}`}
							onClick={() => onViewChange(item.id)}
						>
							{isActive && <div className="aop-nav-active-bar" />}
							<span className="aop-nav-icon-wrap">{Icons[item.icon]}</span>
							<span className="aop-nav-label">{item.label}</span>
							{item.proto && isTestEnv && <span className="aop-badge proto">WIP</span>}
							{item.pendingBadge && pendingCount > 0 && (
								<span className="aop-nav-badge">{pendingCount}</span>
							)}
						</div>
					);
				})}
			</nav>

			{isTestEnv && status && (
				<div className="aop-sb-footer">
					<div className="aop-sb-footer-section">
						<div className="aop-sb-footer-heading">
							<div className="aop-sb-footer-label">Status</div>
						</div>
						<div className="aop-sb-footer-row">
							<span
								className="aop-sb-status-dot"
								style={{ background: status.enabled ? "var(--green)" : "var(--orange)" }}
							/>
							Worker: {status.enabled ? "Enabled" : "Disabled"}
						</div>
						<div className="aop-sb-footer-row">
							<span
								className="aop-sb-status-dot"
								style={{ background: status.jobs.failed > 0 ? "var(--red)" : "var(--green)" }}
							/>
							Queue: {status.jobs.pending} pending
							{status.jobs.failed > 0 ? ` · ${status.jobs.failed} failed` : ""}
						</div>
					</div>
					<div className="aop-sb-footer-section">
						<div className="aop-sb-footer-label">Environment</div>
						<div className="aop-sb-footer-text">
							Write Policy:{" "}
							<strong>
								{status.writePolicy === "human_approval" ? "Human Approval" : status.writePolicy}
							</strong>
						</div>
						<div className="aop-sb-footer-row">
							<span style={{ color: "var(--text-sec)", fontSize: 13 }}>Dry Run:</span>
							<span
								className="aop-nav-badge"
								style={
									status.dryRun
										? { background: "rgba(247,147,26,0.15)", color: "#f7931a" }
										: { background: "rgba(52,199,89,0.15)", color: "var(--green)" }
								}
							>
								{status.dryRun ? "Enabled" : "Disabled"}
							</span>
						</div>
					</div>
				</div>
			)}
		</aside>
		</>
	);
}
